import { superbadgeMap } from "../assets/certImages/superbadgeImages";

export default function Modal({ doc, onClose }) {
    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <button className="close-btn" onClick={onClose}>
                    X
                </button>

                <h2>{doc.name}</h2>
                <div className="modalContainer">
                    <img
                        src={superbadgeMap[doc.hiddenName] || null}
                        alt={doc.name}
                        className="modalImage"
                    />
                    <div className="modalDetailsCompleted">
                        <p>{doc.description}</p>
                        <p>Completed{" "}
                            {doc.completed?.toDate
                                ? doc.completed
                                    .toDate()
                                    .toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    })
                                : "Date unknown"}
                        </p>

                        <div className="tagRow">
                            {doc.tags?.map((tag) => (
                            <span
                                key={tag}
                                className="modalTagChip"
                            >
                                {tag}
                            </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}